/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs */

const en_admin_resources_resource_allocations_status_ending_soon = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ending soon`)
};

const de_admin_resources_resource_allocations_status_ending_soon = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endet bald`)
};

const es_admin_resources_resource_allocations_status_ending_soon = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizando pronto`)
};

const fr_admin_resources_resource_allocations_status_ending_soon = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bientôt fini`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_status_ending_soon = en_admin_resources_resource_allocations_status_ending_soon;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_status_ending_soon = en_admin_resources_resource_allocations_status_ending_soon;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_status_ending_soon = en_admin_resources_resource_allocations_status_ending_soon;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_status_ending_soon = en_admin_resources_resource_allocations_status_ending_soon;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_status_ending_soon = en_admin_resources_resource_allocations_status_ending_soon;

/**
* | output |
* | --- |
* | "Ending soon" |
*
* @param {Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_status_ending_soon = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Status_Ending_SoonInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_status_ending_soon(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_status_ending_soon(inputs)
	return ro_admin_resources_resource_allocations_status_ending_soon(inputs)
});
export { admin_resources_resource_allocations_status_ending_soon as "admin.resources.resource_allocations.status_ending_soon" }